import RulesDetails from './RulesDetails';

export { RulesDetails };
export default RulesDetails;
